<template>
  <div class="ab-ui-card">
    <div v-if="$slots.header" class="ab-ui-card__header">
      <slot name="header" />
    </div>
    <div class="ab-ui-card__body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="ab-ui-card__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AbUiCard',
}
</script>

<style scoped>
.ab-ui-card {
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
  padding: 16px;
}

.ab-ui-card__header {
  margin-bottom: 12px;
}

.ab-ui-card__body {
  font-size: 13px;
}

.ab-ui-card__footer {
  margin-top: 12px;
}
</style>

